var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { mergeClassName } from 'lib/utils';
import { Loading } from '@aptive-env/storybook';
var Loader = function (_a) {
    var className = _a.className;
    return (_jsx("div", __assign({ className: mergeClassName('flex justify-center', className) }, { children: _jsx(Loading, { className: 'loading' }) })));
};
export default Loader;
